import { getUserId, meQueryOptions } from "@/api/auth";
import { myWalletQueryOptions } from "@/api/me";
import { infiniteTransactionsQueryOptions } from "@/api/transactions";
import { queryClient } from "@/api/utils";
import { captureCustomEvent } from "@/utils/posthog";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { fallback, object, optional, string } from "valibot";

const REFETCH_AFTER_TOPUP_DELAY = 3000;

/**
 * Literally all this does is wait a bit and then send you wherever you need to go.
 */
export const Route = createFileRoute("/_auth/_app/top-up/complete")({
  validateSearch: object({
    payment_intent: fallback(optional(string()), undefined),
    payment_intent_client_secret: fallback(optional(string()), undefined),
    redirect_status: fallback(optional(string()), undefined),
  }),
  beforeLoad: async ({ search }) => {
    captureCustomEvent("member_topped_up_tokens", {});
    function redirectAppropriately() {
      const returnTo = search["return-to"];

      if (returnTo) {
        throw redirect({
          to: returnTo as any,
        });
      } else {
        throw redirect({
          to: "/wallet",
        });
      }
    }

    // Get user ID for refetching
    await queryClient.prefetchQuery(meQueryOptions);
    const userId = getUserId();

    // Sleep an arbitrary amount of time, could alteratively poll the wallet until the topup is complete
    await sleep(REFETCH_AFTER_TOPUP_DELAY);

    // Refetch wallet
    await queryClient.refetchQueries(myWalletQueryOptions);
    await queryClient.refetchQueries(infiniteTransactionsQueryOptions(userId));
    redirectAppropriately();
  },
});

const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
